import styles from './ContactPage.module.css';

function ContactPage() {
  return (
    <div className={styles.page}>
      <section className={styles.content}>
        <h1 className={styles.title}>Contact Hub Pub</h1>
        <h3 className={styles.label}>Email</h3>
        <p className={styles.value}>hubpubboston@gmail.com</p>
        <h3 className={styles.label}>Call</h3>
        <p className={styles.value}>617-227-8952</p>
        <h3 className={styles.label}>Address</h3>
        <p className={styles.value}>18 Province Street<br />Boston MA, 02108</p>
        <p className={styles.legal}>MRJ INC. HUB PUB DBA</p>
      </section>
    </div>
  );
}

export default ContactPage;
